export default "__VITE_PUBLIC_ASSET__0d0580be__"